module.exports = __webpack_public_path__ + "img/banner.45bcf241.png";